import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { HIDDEN, FADE } from '../../HOME/const';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';
import HelpIcon from '../../HOME/SVG/HelpIcon';
import { setGlobalOption, requestResetStats } from '../../HOME/REDUX/actions';
import { showHelp } from '../REDUX/actions';

class Options extends Component {
  handleResetStats = e => {
    if (this.canResetStats()) {
      this.props.hideOptions();
      this.props.requestResetStats(true);
    }
  };

  canResetStats = () => {
    const { stats } = this.props;
    return stats && stats.plays > 0;
  };

  handleHelp = () => {
    this.props.hideOptions();
    this.props.showHelp(true);
  };

  render() {
    const { op } = this.props;
    const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

    return (
      <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
        <div className="options-x" onClick={this.props.hideOptions}>
          ×
        </div>
        <div className={`options-item${this.canResetStats() ? '' : ' options-item-disabled'}`} onClick={this.handleResetStats}>
          <ResetStatsIcon width="30" />
          <span>reset stats</span>
        </div>
        <div className="options-item" onClick={this.handleHelp}>
          <HelpIcon width="30" />
          <span>how to play</span>
        </div>
        <VolumeControl />
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, setGlobalOption, showHelp }
)(Options);
